import * as NOTICE from 'gadjet-v2-types/dist/api/hq/notice'

import axios from '@utils/axios'

const HqNoticeAPI = {
  // 공지사항 조회
  getNotices: async (
    { hqId }: NOTICE.GET_LIST_PARAMS,
    query: NOTICE.GET_LIST_QUERY
  ): Promise<{ data: NOTICE.GET_LIST_RESPONSE }> => axios.get(`/hqs/${hqId}/notices`, { params: query }),

  // 공지사항 상세 조회
  getNoticeDetail: async ({
    hqId,
    noticeId,
  }: NOTICE.GET_DETAIL_PARAMS): Promise<{ data: NOTICE.GET_DETAIL_RESPONSE }> =>
    axios.get(`/hqs/${hqId}/notices/${noticeId}`),

  // 공지사항 추가
  addNotice: async ({ hqId }: NOTICE.ADD_PARAMS, { notice }: NOTICE.ADD_BODY): Promise<{ data: NOTICE.ADD_RESPONSE }> =>
    axios.post(`/hqs/${hqId}/notices`, { notice }),

  // 공지사항 수정
  updateNotice: async (
    { hqId, noticeId }: NOTICE.UPDATE_PARAMS,
    { notice }: NOTICE.UPDATE_BODY
  ): Promise<{ data: NOTICE.UPDATE_RESPONSE }> => axios.put(`/hqs/${hqId}/notices/${noticeId}`, { notice }),

  // 공지사항 삭제
  deleteNotice: async ({ hqId, noticeId }: NOTICE.DELETE_PARAMS): Promise<{ data: NOTICE.DELETE_RESPONSE }> =>
    axios.delete(`/hqs/${hqId}/notices/${noticeId}`),
}

export default HqNoticeAPI
